import React,{useState, useEffect} from 'react';
import {doGet, doPatch, doDownloadUsers, doDownloadPdf} from 'utils/apiUtil.js'
import {endpoint} from 'utils/constants.js'
import { Redirect,useRouteMatch, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';

import ArrowBack from '@material-ui/icons/ArrowBack';
import Paper from '@material-ui/core/Paper';
import DebouncedTextField from 'components/DebouncedTextField.js';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { format, parse, isAfter } from 'date-fns'
import Select from 'react-select'
import {selectCustomZindex} from 'utils/theme'
import numeral from 'numeral'
import TablePagination   from '@material-ui/core/TablePagination';
import { generalListOptionMapper } from 'utils/mappers.js';
import FormUser from './FormUser';

const PembelianBuku =(props)=> {

  let { path, url } = useRouteMatch();
  let history = useHistory();
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const [users, setusers] = useState([]);
  const [selectedUser, setselectedUser] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  

  const [paymentTypeOptions, setpaymentTypeOptions] = useState([
    {label:'Manual', value:1},
    {label:'Transfer', value:2} 
  ]);


  const [locationOptions, setlocationOptions] = useState([])

  const [filters, setfilters] = useState({
    status:null,
    keyword:""
  });
  const [openDialog, setopenDialog] = React.useState(false);
  const [dialogWidth, setdialogWidth] = useState('sm');
  const [dialogContent, setdialogContent] = useState(null);
  const [dialogTitle, setdialogTitle] = useState('title');
 
  const getDefaultHeader =()=>{
    return {"Authorization":`Bearer ${user.token}`}
  }

  const changePage=(event, newPage)=>{
    setPage(newPage+1)
  }

  const changeRowsPerPage = (event)=> {
      setRowsPerPage(+event.target.value);
      setPage(1);
  }

  
  const back =()=>{
    history.goBack()
  }

  const getlocationOptions =async()=>{
    const params={}
        
    const response = await doGet(endpoint.location, params, getDefaultHeader());        
    if(!response.error){
      const locations = response.data      
      setlocationOptions(generalListOptionMapper(locations))
    }
  }


  const getusers =async()=>{
    const params={
      keyword : filters.keyword.trim()!==""?filters.keyword : null,
      sort:filters.sort?filters.sort.value:null,
      page:page,
      limit:rowsPerPage
    }
        
    const response = await doGet(endpoint.users, params, getDefaultHeader());        
    if(response && response.data && response.data.data){
      const users = response.data.data      
      setusers(users)
      setPage(response.data.current_page)
      setTotalRows(response.data.total)
    }    
    
  }  

  const exportusers =async()=>{
    const params={
      keyword : filters.keyword.trim()!==""?filters.keyword : null,
      sort:filters.sort?filters.sort.value:null
    }
        

    const response = await doDownloadUsers(endpoint.users_export, params, getDefaultHeader());        
    
    
  }  

  const showDetail =(order)=>{
    setselectedUser(order)    
  }



  const closeDialog =()=>{    
    setopenDialog(false)
    setselectedUser(null)
  }  
  
  const filtersChange =(fieldName, event)=>{    
    let newFilters = {...filters}
    let value = event

    newFilters[fieldName] = value    
    setfilters(newFilters)
  }


 

    useEffect(() => {    
    if(selectedUser){
      setdialogTitle('Data User')
      setdialogContent(<FormUser 
        getusers={getusers} 
        user={user} 
        selectedUser={selectedUser} 
        handleClose={closeDialog}/>)
      setdialogWidth('md')
      setopenDialog(true)
    }
  }, [selectedUser])
  
   
  useEffect(() => {
    getlocationOptions()
  }, []) 

  useEffect(() => {
    getusers()
  }, [page,rowsPerPage])  


  useEffect(() => {
    getusers()
  }, [filters.keyword])
  

  if(user && user.token){
    return (
      <React.Fragment>
        <CssBaseline/>
        <Grid container alignItems='flex-start' alignContent="flex-start"  className={classes.root}>
            <Grid item xs={1}>              
                <IconButton color="primary" aria-label="go back" component="span" onClick={back}>
                  <ArrowBack />
                </IconButton>              
            </Grid>
            <Grid container item xs={11} justify="flex-end" alignItems="center" >                                                    
                
            </Grid>          
            
            <Paper elevation={1} style={{width:'100%', margin:'4px 0', padding:8}}>
                <Grid container spacing={1} alignItems="center" >                                                    
                    <Grid item xs={6} md={3} >
                      <DebouncedTextField
                          margin="dense"
                          id="keyword"
                          placeholder="Cari data user..."                                                                                   
                          fullWidth
                          variant="outlined"
                          value={filters.keyword}
                          onChange={(e)=>{filtersChange('keyword',e)}}
                      />
                    </Grid>

                    

                      {users && users.length > 0 && (
                     <Grid item xs={3} >
                      <Button variant="contained" size="small" onClick={exportusers} color="primary" style={{margin:'0 8px'}}>
                        Export Excell
                      </Button>
                     </Grid>    
                    )}      
                    
                </Grid>
                                     
            </Paper>
            
            
                <Grid container justify="center" style={{margin:'4px 0'}}>                                           
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow className={classes.rowHead}>
                                    <TableCell align="left" className={classes.cellHead}>ID</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>No&nbsp;Formulir</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>NIY</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Nama&nbsp;Siswa</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Email&nbsp;Login</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Email&nbsp;Verify</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Nama&nbsp;Orang&nbsp;Tua</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Phone</TableCell>
                                    <TableCell align="left" className={classes.cellHead}>Tgl&nbsp;Daftar</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {users && users.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell align="left" onClick={()=>showDetail(row)} className={classes.clickable}>{row?.id}</TableCell>
                                    <TableCell align="left" onClick={()=>showDetail(row)} className={classes.clickable}>{row?.no_formulir ?? '-'}</TableCell>
                                    <TableCell align="left" onClick={()=>showDetail(row)} className={classes.clickable}>{row?.niy ?? '-'}</TableCell>
                                    <TableCell align="left" onClick={()=>showDetail(row)} className={classes.clickable}>{row?.name_student}</TableCell>
                                    <TableCell align="left">{row?.email} </TableCell>
                                    <TableCell align="left">{row?.email_verified_at
                                      ? new Date(row.email_verified_at).toLocaleString()
                                      : '-'} </TableCell>
                                    <TableCell align="left">{row?.name_parent} </TableCell>
                                    <TableCell align="right">{row?.telephone} </TableCell>
                                    <TableCell align="left">{row?.created_at
                                      ? new Date(row.created_at).toLocaleString()
                                      : '-'} </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        <Grid container justify="flex-end" className={classes.paginationContainer}>
                          <TablePagination
                              rowsPerPageOptions={[10, 25, 50]}
                              component="div"
                              count={totalRows}
                              rowsPerPage={rowsPerPage}
                              page={page-1}
                              backIconButtonProps={{
                                  'aria-label': 'previous page',
                              }}
                              nextIconButtonProps={{
                                  'aria-label': 'next page',
                              }}
                              onChangePage={changePage}
                              onChangeRowsPerPage={changeRowsPerPage}
                          />
                        </Grid>
                    </TableContainer>
                </Grid>            
            
            
        </Grid>

        <Dialog
        fullWidth={true}
        maxWidth={dialogWidth}
        open={openDialog}
        onClose={closeDialog}
        aria-labelledby="max-width-dialog-title"
        >
            <DialogTitle id="max-width-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>
                {dialogContent}
            </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
  else{
    return <Redirect to={{ pathname: '/login' }} />
  }

}

const useStyles = makeStyles((theme) => ({
    marginTop16:{
      marginTop:16  
    },  
    marginH4:{
      marginLeft:4,
      marginRight:4,
    },  
    root: {
      padding: theme.spacing(1)
    },
    rowHead:{
      backgroundColor:'#d5ecff'
    },
    cellHead:{
      color:'#2532d4',
      fontWeight:'bold'
    },
    clickable:{
      color:theme.palette.primary.main,
      fontWeight:'bold',
      cursor:'pointer'
    }
    
    
  }));


export default PembelianBuku;
